export const PERSONAL_FIELDS = [
  { name: "fullName", label: "Full Name", type: "text", placeholder: "Your full name", required: true },
  {
    name: "gender",
    label: "Gender",
    type: "select",
    required: true,
    options: ["Male", "Female", "Other", "Prefer not to say"],
  },
  { name: "dateOfBirth", label: "Date of Birth", type: "date", required: true },
  { name: "exactTimeOfBirth", label: "Exact Time of Birth", type: "time", required: true },
  {
    name: "placeOfBirth",
    label: "Place of Birth (City/Country)",
    type: "text",
    placeholder: "City, Country",
    required: true,
  },
  {
    name: "currentLocation",
    label: "Current Location",
    type: "text",
    placeholder: "Current city, state, or country",
    required: true,
  },
  { name: "phoneOrWhatsApp", label: "Phone / WhatsApp", type: "tel", placeholder: "Phone number", required: true },
  { name: "email", label: "Email", type: "email", placeholder: "name@example.com", required: true },
];

export const CONSULTATION_SECTIONS = [
  {
    key: "generalPanchangAndMuhurat",
    title: "General Panchang & Muhurat",
    options: [
      "Today’s Panchang",
      "Daily Auspicious/Inauspicious Times",
      "Best Time for Important Work",
      "Rahu Kaal / Yamagandam / Gulika",
      "Choghadiya",
      "Abhijit Muhurat",
      "Brahma Muhurat",
      "Good Day Selection",
      "Travel Muhurat",
      "Business Opening Muhurat",
      "Vehicle Purchase Muhurat",
      "Housewarming (Griha Pravesh)",
      "Bhoomi Pujan / Construction Start",
      "Property Purchase",
      "Shop Opening",
      "Naming Ceremony (Naamkaran)",
      "Annaprashan",
      "Mundan",
      "Vidyarambh",
      "Upanayan",
      "Engagement",
      "Marriage Muhurat",
      "Caesarean Delivery Muhurat",
      "Surgery Muhurat",
      "Moving Date",
      "Starting New Job",
      "Foreign Travel Muhurat",
      "Exam Muhurat",
      "Investment Muhurat",
    ],
  },
  {
    key: "janmaKundali",
    title: "Janma Kundali / Birth Chart Related",
    options: [
      "Full Birth Chart Reading",
      "Lagna / Ascendant Analysis",
      "Moon Sign (Rashi)",
      "Nakshatra",
      "Planetary Strengths & Weaknesses",
      "Yogas in Chart",
      "Doshas in Chart",
      "Manglik Check",
      "Kal Sarpa Dosha",
      "Pitra Dosha",
      "Sade Sati",
      "Mahadasha / Antardasha",
      "Current Transit Effects (Gochar)",
      "Career Analysis",
      "Financial Analysis",
      "Business Prospects",
      "Marriage Prospects",
      "Relationship Compatibility",
      "Children Prospects",
      "Health Analysis",
      "Spiritual Growth",
      "Foreign Settlement",
      "Education Guidance",
      "Property & Real Estate",
      "Court / Legal Matters",
      "Remedies & Parihar",
    ],
  },
  {
    key: "marriageCompatibility",
    title: "Marriage / Compatibility",
    options: [
      "Kundali Matching",
      "Guna Milan",
      "Manglik Matching",
      "Compatibility Analysis",
      "Marriage Timing",
      "Relationship Obstacles",
      "Divorce / Separation Concerns",
      "Second Marriage Analysis",
    ],
  },
  {
    key: "healthSpiritual",
    title: "Health & Spiritual Concerns",
    options: [
      "Health Issues",
      "Mental Peace / Anxiety",
      "Negative Energy Concerns",
      "Nazar / Drishti",
      "Graha Shanti",
      "Pitru Related Issues",
      "Family Problems",
      "Obstacles / Delays",
      "Sleep Disturbances",
      "Spiritual Guidance",
      "Mantra Recommendation",
      "Deity Guidance",
      "Fasting Guidance",
      "Temple Remedies",
      "Gemstone Recommendation",
      "Rudraksha Recommendation",
    ],
  },
  {
    key: "festivalVrat",
    title: "Festival / Vrat Related",
    options: [
      "Ekadashi Guidance",
      "Navratri Guidance",
      "Shraddha / Pitru Paksha",
      "Sankranti",
      "Purnima / Amavasya",
      "Eclipse Guidance",
      "Fasting Rules",
      "Festival Muhurat",
      "Puja Procedure Guidance",
    ],
  },
  {
    key: "templeRitual",
    title: "Temple / Ritual Services",
    options: [
      "Satyanarayan Katha",
      "Griha Shanti",
      "Navagraha Puja",
      "Rudrabhishek",
      "Durga Saptashati Path",
      "Chandi Havan",
      "Ganesh Puja",
      "Lakshmi Puja",
      "Hanuman Puja",
      "Wedding Ceremony",
      "Upanayan Ceremony",
      "Bhoomi Pujan",
      "Vaastu Puja",
      "Antyeshti / Funeral Rites",
      "Shraddha / Tarpan",
      "Other",
    ],
  },
  {
    key: "vaastu",
    title: "Vaastu Related",
    options: [
      "Home Vaastu Check",
      "Office Vaastu",
      "Temple Placement",
      "Kitchen Placement",
      "Bedroom Placement",
      "Entrance Direction",
      "Plot Selection",
      "Business Vaastu",
      "Remedies Without Demolition",
    ],
  },
  {
    key: "numerology",
    title: "Numerology / Name Related",
    options: [
      "Name Correction",
      "Baby Name Suggestions",
      "Business Name Suggestions",
      "Numerology Analysis",
      "Lucky Numbers",
      "Signature Guidance",
    ],
  },
];

export const PARTNER_FIELDS = [
  { name: "partnerName", label: "Partner Name", type: "text", placeholder: "Partner name" },
  { name: "partnerDob", label: "DOB", type: "date" },
  { name: "partnerTimeOfBirth", label: "Time of Birth", type: "time" },
  { name: "partnerPlaceOfBirth", label: "Place of Birth", type: "text", placeholder: "City, Country" },
];

export const DOCUMENT_OPTIONS = [
  "Birth Chart",
  "Previous Astrology Reports",
  "House Floor Plan (for Vaastu)",
  "Photos of Property/Temple",
  "Marriage Details",
  "Medical Reports (optional)",
  "Other Relevant Documents",
];

export const CONSULTATION_TYPES = [
  "In Person",
  "Phone Call",
  "WhatsApp",
  "Zoom / Video Call",
];

export const createInitialFormData = () => ({
  personalInformation: {
    fullName: "",
    gender: "",
    dateOfBirth: "",
    exactTimeOfBirth: "",
    placeOfBirth: "",
    currentLocation: "",
    phoneOrWhatsApp: "",
    email: "",
  },
  checkedItems: CONSULTATION_SECTIONS.reduce((accumulator, section) => {
    accumulator[section.key] = [];
    return accumulator;
  }, {}),
  partnerDetails: {
    partnerName: "",
    partnerDob: "",
    partnerTimeOfBirth: "",
    partnerPlaceOfBirth: "",
  },
  additionalQuestionsOrConcerns: "",
  documentsToProvide: [],
  preferredConsultationType: "",
  otherTempleService: "",
});

export const buildSubmissionPayload = (formData) => ({
  personalInformation: formData.personalInformation,
  checkedItems: formData.checkedItems,
  partnerDetails: formData.partnerDetails,
  additionalQuestionsOrConcerns: formData.additionalQuestionsOrConcerns,
  documentsToProvide: formData.documentsToProvide,
  preferredConsultationType: formData.preferredConsultationType ? [formData.preferredConsultationType] : [],
  otherTempleService: formData.otherTempleService,
});

export const countSelections = (formData) => {
  const sectionCount = Object.values(formData.checkedItems).reduce(
    (total, values) => total + values.length,
    0
  );
  return sectionCount + formData.documentsToProvide.length + (formData.preferredConsultationType ? 1 : 0);
};
